// src/components/Analitics.js
import { useEffect } from 'react';

function Analitics() {
  useEffect(() => {
    console.log("Entra en Analitics");
    // 1) Inicializamos las colas y el objeto global
    window.heapReadyCb = window.heapReadyCb || [];
    window.heap = window.heap || [];

    // 2) Definimos el loader
    window.heap.load = function(envId, clientConfig) {
      window.heap.envId = envId;
      clientConfig = clientConfig || {};
      clientConfig.shouldFetchServerConfig = false;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `https://cdn.us.heap-api.com/config/${envId}/heap_config.js`;
      document.getElementsByTagName('script')[0].parentNode.insertBefore(script, document.getElementsByTagName('script')[0]);

      const methods = [
        "init","startTracking","stopTracking","track","resetIdentity","identify",
        "getSessionId","getUserId","getIdentity","addUserProperties","addEventProperties",
        "removeEventProperty","clearEventProperties","addAccountProperties","addAdapter",
        "addTransformer","addTransformerFn","onReady","addPageviewProperties",
        "removePageviewProperty","clearPageviewProperties","trackPageview"
      ];

      methods.forEach(name => {
        window.heap[name] = function() {
          const args = Array.prototype.slice.call(arguments);
          window.heapReadyCb.push({
            name,
            fn: () => window.heap[name].apply(window.heap, args)
          });
        };
      });
    };

    // 3) Carga el SDK con tu ENV_ID real
    window.heap.load("792920947");

    // 4) Identifica al usuario si tenemos email
    const email = localStorage.getItem('email');
    if (email) {
      console.log("Hay email");
      window.heap.identify(email);
    }
    else{
      console.log("No hay email");
    }
  }, []);

  // Este componente no renderiza nada
  return null;
}

export default Analitics;
